module.exports = __webpack_public_path__ + "img/middle.ca81cf56.jpg";